"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListHeader = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var List_1 = require("@caddigital/sok-ui/lib/components/List");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var components_1 = require("components");
var MetaFilter_1 = require("components/MetaFilter");
var Icon_1 = require("components/Icon");
var SortButton = sok_ui_1.Table.SortButton;
var enhanceHeader = (0, recompose_1.compose)((0, recompose_1.shouldUpdate)(function (nextProps, props) {
    return (0, List_1.shallowDiffers)(nextProps.style, props.style) ||
        nextProps.isAllSelected !== props.isAllSelected ||
        nextProps.isAllBookmarked !== props.isAllBookmarked ||
        nextProps.sortBy !== props.sortBy ||
        nextProps.mode !== props.mode;
}));
exports.ListHeader = enhanceHeader(function (_a) {
    var className = _a.className, style = _a.style, currentFolder = _a.currentFolder, projectSchema = _a.projectSchema, isAllSelected = _a.isAllSelected, sortByOptions = _a.sortByOptions, searchOptions = _a.searchOptions, onSelectAll = _a.onSelectAll, onSetColumnFilter = _a.onSetColumnFilter, downloadFolder = _a.downloadFolder, sortBy = _a.sortBy;
    var mode = searchOptions &&
        (searchOptions.searchString !== '' ||
            searchOptions.toggleRecents === true ||
            searchOptions.searchFileType.isSome() ||
            searchOptions.filtering !== 'NONE' ||
            searchOptions.from !== null ||
            searchOptions.to !== null)
        ? 'SEARCH'
        : 'NORMAL';
    return (React.createElement("div", { className: className + ' row', style: style },
        React.createElement("div", { className: "row__column narrow" }),
        React.createElement("div", { className: "row__column narrow select" },
            React.createElement(components_1.TableRowIcon, { icon: 'fa-check', circle: true, className: isAllSelected ? 'selected' : '', onClick: onSelectAll })),
        React.createElement("div", { className: "row__column narrow" },
            React.createElement(Icon_1.Icon, { className: 'sok-icon-download-cloud sok-icon-download-cloud-center', onClick: function () {
                    downloadFolder(currentFolder);
                } })),
        React.createElement("div", { className: "row__column narrow" }),
        projectSchema.map(function (cm) {
            if (cm.id === undefined) {
                return React.createElement("div", null);
            }
            var localization = cm.identifier === 'name-meta'
                ? (0, translation_1.getLocalization)('diaryAttachmentsView/filelist/name')
                : cm.identifier === 'size-meta'
                    ? (0, translation_1.getLocalization)('diaryAttachmentsView/filelist/size')
                    : cm.identifier === 'added-meta'
                        ? (0, translation_1.getLocalization)('diaryAttachmentsView/filelist/added')
                        : cm.identifier === 'added-by-meta'
                            ? (0, translation_1.getLocalization)('diaryAttachmentsView/filelist/addedby')
                            : null;
            var dataKey = '__' + cm.id;
            var order = sortByOptions.sortBy === cm.id && sortByOptions.order === 'desc'
                ? 'desc'
                : 'asc';
            return (React.createElement("div", { className: 'row__column name ' + dataKey },
                React.createElement("div", null, !localization ? cm.name : localization),
                React.createElement(SortButton, { className: "sort d-none d-desktop-table-cell", order: (!sortByOptions.sortBy &&
                        searchOptions.filtering === 'RECENTS') ||
                        sortByOptions.sortBy === cm.id
                        ? sortByOptions.order.toLowerCase()
                        : null, disabled: false, onChange: function () {
                        return sortBy(cm.id, order === 'desc' ? 'asc' : 'desc');
                    } }),
                React.createElement(MetaFilter_1.ColumnFilter, { className: classNames('filter', sortByOptions.filters && sortByOptions.filters[cm.id]
                        ? 'active'
                        : ''), columnIdentifier: cm.id.toString(), textInputValue: sortByOptions.filters && sortByOptions.filters[cm.id]
                        ? sortByOptions.filters[cm.id]
                        : '', meta: cm, setColumnFilterString: function (field, value) {
                        onSetColumnFilter(field, value);
                    }, clearColumnFilter: function (field) {
                        return onSetColumnFilter(field, null);
                    } })));
        })));
});
